/**
 * @module spreads
 */
import { createReducer } from '@reduxjs/toolkit';

const defaultState = {};

const spreads = createReducer(defaultState, () => {});

export default spreads;
